import React, { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'

import { UserAddressCard } from './userAddressCard'
import { User } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  done: Callback
  deleteUserAddress: Callback
  selectAddressCard: Callback
  selectedAddress: string
  user: User
}

export const UserAddressDetails: FunctionComponent<Props> = ({
  done,
  deleteUserAddress,
  selectedAddress,
  selectAddressCard,
  user,
}) => {
  const { addresses, currentAddress } = user

  const addressCards = (addresses) => {
    const currentId = currentAddress && currentAddress.id
    const otherAddresses = addresses.filter((address) => {
      return address.id !== currentId
    })
    return (
      otherAddresses.length >= 1 &&
      otherAddresses.map((address) => {
        const isSelected = address.id === selectedAddress
        return (
          <UserAddressCard
            key={address.id}
            address={address}
            userId={user.id}
            isSelected={isSelected}
            selectAddressCard={selectAddressCard}
          />
        )
      })
    )
  }

  const noAddresses = (
    <p className="user-address__details--empty">No addresses entered</p>
  )

  const headerButtons = (
    <div className="user-address__buttons--manage">
      {selectedAddress && (
        <a
          className="user-address__buttons--delete"
          data-testid="create-address-delete-address"
          aria-label="delete"
          onClick={deleteUserAddress}
        >
          Delete selected
        </a>
      )}
      <NavLink
        className="button button--secondary user-address__buttons--add"
        to={`/users/${user.id}/address/new`}
      >
        Add an Address
      </NavLink>
    </div>
  )

  const isSelected = currentAddress && currentAddress.id === selectedAddress

  return (
    <div className="user-address__details">
      <div className="user-address__details--header">
        <h1 className="user-address__details--title">Manage Addresses</h1>
        {headerButtons}
      </div>
      {addresses.length === 0 ? (
        noAddresses
      ) : (
        <div className="user-address__container">
          {currentAddress && (
            <UserAddressCard
              address={currentAddress}
              status="CURRENT"
              userId={user.id}
              isSelected={isSelected}
              selectAddressCard={selectAddressCard}
            />
          )}
          {addressCards(addresses)}
        </div>
      )}
      <div className="user-address__buttons">
        <button
          className="button button--primary-round"
          data-test="create-address-form-submit"
          onClick={done}
        >
          Done
        </button>
      </div>
    </div>
  )
}

UserAddressDetails.displayName = 'UserAddressDetails'
